import { useTranslation } from 'react-i18next';

export default function WhySection() {
  const { t } = useTranslation();

  const cards = [
    { icon: 'ri-time-line', title: 'why.card1Title', desc: 'why.card1Desc' },
    { icon: 'ri-scales-3-line', title: 'why.card2Title', desc: 'why.card2Desc' },
    { icon: 'ri-fire-line', title: 'why.card3Title', desc: 'why.card3Desc' },
    { icon: 'ri-folder-chart-line', title: 'why.card4Title', desc: 'why.card4Desc' },
  ];

  return (
    <section className="w-full py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-14">
          {t('why.title')}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card) => (
            <div
              key={card.title}
              className="bg-background-50 rounded-2xl p-8 border border-background-200/60 hover:border-accent-300 transition-colors group cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${card.icon} text-xl text-accent-500`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-3">
                {t(card.title)}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t(card.desc)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}